export { DashboardLayout, type DashboardLayoutProps } from "./dashboard-layout";
